import { withAuthenticationRequired } from '@tom-ui/utils'
import { YardSelectorProps } from '@tom-ui/planning'
import YardClerkPage from '@tom-ui/planning/pages/YardClerk/YardClerkPage'
import { useYardStores, YardPositionSelector } from '@tom-ui/yard'
import { observer } from 'mobx-react-lite'
import { useCallback } from 'react'

export const YardClerk = withAuthenticationRequired(
  observer(() => {
    const { yardPositionSelectorStore } = useYardStores()

    const renderYardPositionSelector = useCallback(
      ({
        hasError,
        onPositionChange,
        journeyId,
        stackDirection,
        prefillPosition,
      }: YardSelectorProps) => {
        return (
          <YardPositionSelector
            journeyId={journeyId!}
            hasError={hasError}
            stackDirection={stackDirection}
            prefillPosition={prefillPosition}
            onChange={(value: any) => onPositionChange?.(!!value)}
          />
        )
      },
      [],
    )

    const handleUpdatePosition = async (journeyId: number) => {
      await yardPositionSelectorStore.stackInJourney(journeyId)
    }

    return (
      <YardClerkPage
        yardSelector={renderYardPositionSelector}
        handleUpdatePosition={handleUpdatePosition}
      />
    )
  }),
)
